appSocial.constant('en_Locale', {
    'fontPreloaderText': 'Social Trading App PandaTs',
    'leaders': 'Leaders',
    'collections': 'Collections',
    'myActivity': 'My activity',

    'all': 'All',
    'allCountries': 'All Countries',
    'searchCountry': 'Search Country...',
    'from': 'From',
    'to': 'To',
    'market': 'Market',
    'allMarkets': 'All Markets',
    'minGainOf': 'Min. Gain of',
    'enterGain': 'Enter Gain',
    'risk': 'Risk',
    'duringThe': 'During The',
    'totalTrades': 'Total Trades',
    'avgTradeSize': 'Avg. Trade Size',

    'myPortfolio': 'My Portfolio',
    'myFavorites': 'My Favorites',

    'forex': 'Forex',
    'crypto': 'Crypto',
    'spot': 'Spot',
    'commodities': 'Commodities',
    'stocks': 'Stocks',
    'indices': 'Indices',
    'currencies': 'Currencies',
    'etfs': 'ETFS',
    'shares': 'Shares',

    'low': 'Low',
    'medium': 'Medium',
    'high': 'High',

    'currentMonth': 'Current Month',
    'lastMonth': 'Last Month',
    'lastTwoMonth': 'Last 2 Months',
    'currentQuarter': 'Current Quarter',
    'lastThreeMonth': 'Last 3 Months',
    'lastSixMonth': 'Last 6 Months',
    'thisYear': 'This Year',
    'thisTwoYears': 'These 2 Years',

    'gain': 'Gain',
    'trades': 'Trades',
    'invCapital': 'Inv. Capital',
    'copiers': 'Copiers',
    'copy': 'Copy',
    'resume': 'Resume',

    'orderBy': 'Order By',

    'registration': {
        'step01': {
            'title': 'Easy, simple, profitable',
            'text01': `Online trading has never been easier.<br/>Meet our new social trading platform - Cooma.</br>Today more than ever, it is easy to keep track of the successful traders and copy their trades.`,
            'text02': 'Check here to indicate that you have read and agree to the Social Trading Terms and Conditions',
        }
    },

    'leadersWidget': {
        'most-copied': 'Most Copied',
        'editors-choice': 'Editors` Choice',
        'profitable': 'Most Profitable',
        'trending': 'Trending',
        'top': 'Top Investors',
        'similar': 'Similar leaders',
    },

    'mostCopied': 'Most Copied',
    'absGain': 'Abs. Gain',
    'avgTradeTime': 'Avg. Trade Time',
    'followers': 'Followers',
    'back': 'Back',
    'backToTop': 'Back to top',
    'verifiedUser': 'Verified User',
    'activeSince': 'Active Since',
    'lastActive': 'Last Active',
    'lastTradingActivity': 'Last Trading Activity',
    'unknownCountry': 'Country is unknown',

    'startCopyTradesFromProfitableTraders': 'Start copy trades from profitable traders',
    'statistics': 'Statistics',

    'month': 'month',
    'months': 'months',
    'week': 'week',
    'weeks': 'weeks',
    'day': 'day',
    'days': 'days',
    'hour': 'hour',
    'hours': 'hours',
    'minute': 'minute',
    'minutes': 'minutes',
    'second': 'second',
    'seconds': 'seconds',

    'leaderName': 'Leader Name',
    'country': 'Country',
    'riskLevel': 'Risk Level',
    'favorite': 'Favorite',

    'compare': 'Compare',
    'close': 'Close',

    'profitable': 'Profitable',
    'assets': 'Assets',
    'investedCapital': 'Invested Capital',
    'copiersNumber': 'Copiers Number',
    'popularity': 'Popularity',
    'drawdown': 'Drawdown',
    'numberOfTrades': 'Number of trades',
    'tradesCount': 'Total Trades',
    'currentCopiers': 'Current Copiers',
    'winningTrades': 'Winning Trades',
    'maxDrawdown': 'Max. Drawdown',
    'noOfViews': 'No. of views',
    'compareLeaders': 'Compare Leaders',
    'viewMoreParams': 'View more parameters',
    'minimizeParameters': 'Minimize parameters',
    'remove': 'Remove',
    'comparisonCategories': 'Comparison Categories',
    'followersCount': 'Followers Count',
    'copyFrom': 'Copy From',
    'leaderPerformance': 'Leader performance',
    'oneYearGain': '1 Year Gain',
    'lastSevenDays': 'Last 7d',
    'performance': 'Performance',
    'highest': 'Highest',
    'lowest': 'Lowest',
    'avgProfit': 'Avg. profit',
    'avgLoss': 'Avg. loss',
    'profitFactor': 'Profit factor',
    'addOrDragLeader': 'Add or drag a leader to compare from the list below',
    'profit': 'Profit',
    'portfolio': 'Portfolio',
    'currentPortfolio': 'Current Portfolio',
    'history': 'History',
    'perCentOfPort': '% of Port.',
    'initial': 'Initial',
    'inOut': 'moneyInOut',
    'pl_s': 'P/L (s)',
    'pl_percent': 'P/L %',
    'startCopy': 'Start copy',
    'currentValue': 'Current value',
    'portfolioSummary': 'Portfolio summary',
    'socialAllocation': 'Social Allocation',
    'invested': 'Invested',
    'openTime': 'Open time',
    'closeTime': 'Close time',
    'endValue': 'End value',
    'historySummary': 'History summary',
    'initialAmount': 'Initial amount',
    'endAmount': 'End amount',
    'buy': 'Buy',
    'sell': 'Sell',
    'buy_limit': 'Buy Limit',
    'buy_stop': 'Buy Stop',
    'sell_limit': 'Sell Limit',
    'sell_stop': 'Sell Stop',
    'openTrades': 'Open Trades',
    'closedTrades': 'Closed Trades',
    'tradesNotFound': 'There is no trading activity for the selected period',
    'resetFilter': 'Reset filter',
    'dataRefers': '* The following data refer to Social Trade only (Copied trades) and not to manual open trades',
    'exposure': 'Exposure',
    'allocation': 'Allocation',
    'others': 'Others',
    'youHaveNoLeaders': 'You have no active copied leaders in your social portfolio at this time',
    'discoverLeaders': 'Discover leaders',
    'favorites': 'Favorites',
    'favoritesList': 'Favorites list',
    'recentlyInvested': 'Recently invested',
    'recentlyViewed': 'Recently viewed',
    'myInvest': 'My invest',
    'leaderRate': 'Leader rate',
    'avgRisk': 'Avg. risk',
    'numOfCopiers': '# copiers',
    'copiersValue': 'Copiers value',
    'copyLeader': 'Copy Leader',
    'amount': 'Amount',
    'setBalanceDrop': 'Set Balance drops below',
    'stopCopyingIfCopyDrops': 'Stop copying if copy amount drops below',
    'stopCopyingIfAmountDrops': 'Stop copying if amount drops below',
    'copyOpenTrades': 'Copy open trades',
    'amountEqual1': 'The amount is equal to',
    'amountEqual2': 'which is your base currency',
    'minAmount': 'Minimum amount is',
    'maxAmount': 'Maximum amount is',
    'deposit': 'Deposit',
    'inOrderToOpen': 'in order to open this copy',
    'edit': 'Edit',
    'setBalanceDropsBelow': 'Set balance drops below',
    'leaderCopyFooter': 'Risk Warning: Contracts For Difference (CFD) are complex instruments and come with a high risk of losing money rapidly due to leverage. Certain percentage of retail investor accounts lose money when trading CFDs with this provider. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money. Please read the full Risk Disclosure Statement.',
    'clearFilter': 'Clear Filter',
    'customSearch': 'Custom search',
    'loadMore': 'Load more',
    'loading': 'Loading',
    'seeAll': 'See all',
    'sinceTheBeginning': 'Since the beginning of activity',
    'addFunds': 'Add funds',
    'removeFunds': 'Remove funds',
    'setStopLoss': 'Set Stop Loss',
    'amountInvested': 'Amount Invested',
    'amountToAdd': 'Amount to add',
    'amountToRemove': 'Amount to remove',
    'stopLossRemains': 'Copy stop loss value remains',
    'pauseCopy': 'Pause Copy',
    'resumeCopy': 'Resume Copy',
    'continueCopy': 'Continue Copy',
    'stopCopy': 'Stop Copy',
    'pnl': 'P/L (%)',
    'addToFavorites': 'Add to favorites',
    'removeFromFavorites': 'Remove from favorites',
    'removeFundsText': '* Removing funds may affect your copy and trading results',
    'continue': 'Continue',
    'pauseCopyText': 'Once you pause copying, new trades will not be opened.',
    'profitAndLoss': 'Profit & Loss',
    'totalCurrentAmount': 'Total current amount',
    'copyActionSuccessfullyPerformed': 'copy action successfully performed',
    'theLeader': 'The leader',
    'leader': 'Leader',
    'nowAdded': 'is now added to your portfolio',
    'success': 'Success',
    'error': 'Error',
    'actionCouldnotBePerformed': 'The action could not be completed due to an error.',
    'tryAgainLater': 'Please try again later.',
    'successfully': 'successfully',
    'toTheLeader': 'to the leader',
    'fromTheLeader': 'from the leader',
    'added': 'added',
    'removed': 'removed',
    'actionPaused': 'Copy action paused',
    'actionResumed': 'Copy action resumed',
    'temporarilyPaused': 'is temporarily paused',
    'returnedToCopy': 'returned to be copied',
    'stopCopyText': 'Once you stop copying this investor all copied positions will be closed',
    'actionStopped': 'Copy action stopped',
    'noCopied': 'is no longer copied',
    'positionsClosed': 'All copied positions are now closed',
    'updatedSuccessfully': 'Updated successfully',
    'currentInvestmentPL': 'Current investment P/L',
    'lifetime': 'Lifetime',
    'gainLastMonth': 'Gain (last month)',
    'absoluteGain': 'Absolute Gain',
    'numberOfViews': 'Number of views',
    'waitingForRival': 'Waiting for a rival...',
    'detach': 'Detach',
    'only5CanCompare': 'Only 5 leaders can be compared at a time',
    'removeFromComparing': 'Remove from comparing',
    'addToCompare': 'Add to compare',

    'messages': {
        'ERR_APP': 'Something went wrong. Please try again later',
        'ERR_UNKNOWN': 'Unknown error. Please try again later',
        'ERR_SYSTEM': 'System error. Please try again later',

        'INVALID_RESPONSE': 'Invalid server response',
        'REQUEST_TIMEOUT': 'Server response is timed out',

        'ERR_AUTH': 'Invalid authorization credentials',
        'ERR_AUTH_SESSION': 'Invalid authorization credentials',
        'ERR_AUTH_TOKEN': 'Invalid authorization credentials',
        'ERR_AUTH_IP': 'Authorization failed. Your IP is not whitelisted',
        'ERR_AUTH_EXPIRED': 'Authorization failed. Your token is expired',

        'ERR_PERMISSIONS': 'Your have no permissions to perform this action',

        'ERR_VALIDATION': 'One or more parameters are not correct',
        'ERR_VALIDATION_NOT_OWNED_BY_BRAND': 'This trader is not owned by your brand',
        'ERR_VALIDATION_SAME': 'Operation can not be performed on the same trader you`re logged in',

        'ERR_EXISTS': 'Record already exists',
        'ERR_EXISTS_TRADER': 'Trader or leader is already exist',
        'ERR_EXISTS_FOLLOW': 'This leader is already copied by',

        'ERR_NOT_FOUND': 'Record is not found',
        'ERR_NOT_FOUND_TRADER': 'Trader or leader is not found',
        'ERR_NOT_FOUND_TRADING_ACCOUNT': 'Trading account is not found'
    },
    'hints': {
        'verifiedUser': 'Hint for verified user',
        'mostCopied': 'Hint for most copied',
        'absGain': 'Absolute gain (Abs. Gain) displays the percentage of gains or losses against all deposits. Thus, each new deposit will affect the absolute gain.<br /><br />Abs.Gain = (Total PnL / Total Deposits) * 100',
        'avgTradeLength': 'Open trades duration - the average time that the trader\'s position is held open.',
        'risk': 'Trade risk evaluation ranked with 1-10 scale, 10 representing the highest risk score.',
        'riskScore': 'Trade risk evaluation ranked with 1-10 scale, 10 representing the highest risk score.',
        'gain': 'Gain is a time-frame-based trading performance indicator that does not affect by balance changes outside of the trading activity.<br /><br />Gain = Time-frame sum (Trade closed PnL / Initial deposit * 100)',
        'statistic': 'Leader\'s trading statistics for the entire period of trading activity:<br />' +
            '- Trades: total number of executed trades<br />' +
            '- Profitable: percent of profitable trades<br />' +
            '- Average profit and loss<br />' +
            '- Profit factor: total profit divided by the total loss (commissions included)<br />' +
            '- Assets: percentage of trading activities by market type',
        'assets': 'Trading activity segmentation by markets - both open and closed orders.',
        'investedCapital': 'Daily summary of all funds allocated to this Leader by users that copied his trading activity (in USD).',
        'followersCount': 'A total of all traders that are actively copying this Leader\'s trading activity.',
        'popularity': 'Leader\'s personal profile views count.',
        'tradedAssets': 'Leader\'s closed orders aggregated by market assets.',
        'favored': 'All traders that marked this Leader as a Favorite.',
        'drawdown': 'Drawdown is the balance highest drop from a peak (highest point - HP) to a valley (lowest point - LP) in percentage.<br /><br />Drawdown = (Highest Point - Lowest point) / Highest point',
        'copyOpenTrades': 'The Leader\'s open positions will be opened at the current market rates in your account, if the market is closed, at the rate once the market opens.',
        'lifetime': 'Lifetime is a time period that a trading account exists.',
        'tradesCount': 'Total Trades',
        'avgWin': 'Winning Trades is a trader\'s number of money-making trades.',
        'registrationDate': 'Active Since is a starting date for the trader\'s trading activity.',
        'lastTradeDate': 'Last Active is a time period from the trader\'s last trading activity.',
    },
    'stopLossHasBeenReached': 'Stop-loss has been reached on this copy and it automatically paused',
    'stopLossReached': 'Stop-loss has been reached',
    'howToProceed': 'Please choose how to proceed',
    'editStopLoss': 'Edit Stop loss',

    'noResults': 'No results found for the selected filters',
    'tryToChangeFilter': 'Try to change your filter restriction or clear your filter settings',
    'clearFilterSettings': 'Clear filter settings',
    'openTradesWillBeCopied': 'Open trades will be copied from the Leader under the current market conditions and rates of the assets.',
    'poweredBy': 'Powered by',
    'recentlyClosedAssets': 'Recently Closed Traded Assets',
    'allAssets': 'All assets',
    'theLeaderHasNoOpenTrades': 'The leader has no open trades at the moment',
    'noTradingActivity': 'There is no trading activity to display for the selected asset/period',
    'errorWhileLoading': 'An error has occurred while loading this data',
    'current': 'Current',
    'depositToContinue': 'Deposit %value% in order to continue',
    'minimumStopLoss': 'The minimum value for stop-loss is 10% of the amount',
    'maximumStopLoss': 'The maximum value for stop-loss is 90% of the amount',

    // mobile message only
    'allCategories': 'All Categories',
    'editorsChoice': 'Editor\'s choice',
    'mostProfitable': 'Most Profitable',
    'trending': 'Trending',
    'topInvestors': 'Top Investors',
    'socialTrade': 'Social Trade',
    'glossary': 'Glossary',
    'noSufficientFunds': 'There are no sufficient funds in your account for order execution.',
    'stopLossUpdated': 'Stop loss updated',
    'stopLossUpdatedSuccessfully': 'Stop loss updated successfully',
    'fundsAdded': 'Funds are added',
    'fundsRemoved': 'Funds are removed',
    'successfullyAdded': `%amount% successfully added. <br/> to the leader %fullName%.`,
    'successfullyRemoved': `%amount% successfully removed. <br/> from the leader %fullName%.`,
    'stopLossFailed': 'Failed to update stop loss',
    'failedAddFunds': 'Failed to add funds',
    'failedRemoveFunds': 'Fail to remove funds',
    'stopLossProcessing': 'Setting stop loss is processing',
    'addingFundsProcessing': 'Adding funds is processing',
    'removingFundsProcessing': 'Removing funds is processing',
    'leaderIsCopied': 'Leader is copied',
    'copyActionStopped': 'Copy action stopped',
    'failedCopy': 'Failed to copy leader',
    'failedStop': 'Failed to stop copy',
    'copyProcessing': 'Copy is processing',
    'stopCopyProcessing': 'Stop copy is processing',
    'minStopLoss': 'Minimum stop loss is',
    'leaderDetails': 'Leader Details',
    'year': 'Year',
    'symbol': 'Symbol',
    'direction': 'Direction',
    'volume': 'Volume',
    'open': 'Open',
    'summary': 'Summary',
    'allowCopyTrading': 'Allow Copy Trading',
    'getStarted': 'Let\'s Get Started',
    'swipeToCompare': 'Swipe to compare',
    'change': 'Change %',
    'vs': 'VS',
    'numOfTrades': '# Trades',
    'numOfViews': '# Views',
    'selected': 'of %num% selected',
    'sortBy': 'Sort By',
    'newestFirst': 'Newest First',
    'oldestFirst': 'Oldest First',
    'filterBy': 'Filter By',
    'location': 'Location',
    'markets': 'Markets',
    'minimalGain': 'Minimal Gain',
    'clearAll': 'Clear All',
    'apply': 'Apply',

    'general': 'General',
    'absoluteGainDescription': `Absolute Gain (Abs. Gain) displays the percentage of gains or losses against all deposits. Thus,
                        each new deposit will affect the absolute gain.
                        Abs. Gain = (Total PnL / Total Deposits) * 100`,
    'averageTradeTime': 'Average Trade Time',
    'openTradesDescription': `Open trades duration - the average time that the trader’s position is held open.`,
    'riskDescription': `Trade risk evaluation ranked with 1-10 scale, 10 representing the highest risk score`,
    'investedCapitalDescription': `Daily summary of all funds allocated to this Leader by users that copied his trading activity
                        (in USD).`,
    'numberOfCopiers': 'Number of Copiers',
    'copiersDescription': `A total of all traders that are actively copying this Leader’s trading activity.`,
    'favoritesDescription': `All traders that marked this Leader as a Favorite.`,

    'showAllMostCopied': 'Show All Most Copied',
    'showAllEditorsChoice': 'Show All Editor\'s choice',
    'showAllMostProfitable': 'Show All Most Profitable',
    'showAllTrending': 'Show All Trending',
    'showAllTopInvestors': 'Show All Top Investors',
    'similarLeaders': 'Similar Leaders',
    'mySocialActivity': 'My Social Trading Activity'
})
